import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "./LandingPremiumPage.css";

const WHATSAPP_URL = "https://wa.me/5493515123347?text=Hola%2C%20quiero%20consultar%20por%20las%20funciones%20premium%20de%20Turnero";

const FEATURES = [
  {
    icon: "🩺",
    title: "Historia clínica completa",
    description:
      "Antecedentes, diagnóstico, evolución y documentación clínica integrada por paciente.",
  },
  {
    icon: "🦷",
    title: "Odontograma interactivo",
    description: "Registro visual por pieza dental con historial y seguimiento de tratamientos.",
  },
  {
    icon: "📋",
    title: "Prescripciones y recetas",
    description: "Generá recetas con membrete y firma personalizados, listas para imprimir.",
  },
  {
    icon: "📷",
    title: "Radiografías",
    description: "Archivá y consultá imágenes radiográficas vinculadas a cada paciente.",
  },
  {
    icon: "💰",
    title: "Prestaciones y pagos por paciente",
    description: "Control de costos, abonos, saldos y seguimiento financiero individual.",
  },
  {
    icon: "📅",
    title: "Seguimiento clínico",
    description: "Notas de evolución, recordatorios y trazabilidad de cada tratamiento.",
  },
  {
    icon: "📊",
    title: "Finanzas completas",
    description: "Gestión de gastos, balances detallados y envío de reportes por email.",
  },
  {
    icon: "👥",
    title: "Múltiples profesionales",
    description: "Administrá un equipo: varios odontólogos en una misma clínica.",
  },
  {
    icon: "⚙️",
    title: "Configuración de clínica",
    description: "Membrete, logo, pie de página y firma para documentos profesionales.",
  },
];

export default function LandingPremiumPage() {
  const navigate = useNavigate();

  return (
    <div className="premium-page">
      <Sidebar />
      <main className="premium-content">
        <button type="button" className="premium-back" onClick={() => navigate(-1)}>
          ← Volver
        </button>

        <header className="premium-hero">
          <span className="premium-badge">Funciones premium</span>
          <h1>Ampliá las herramientas de tu consultorio</h1>
          <p>
            Tu cuenta ya incluye calendario y WhatsApp. Sumá funciones premium para historia clínica,
            odontograma, finanzas completas, equipo y documentación profesional.
          </p>
        </header>

        <div className="premium-grid">
          {FEATURES.map((f) => (
            <article key={f.title} className="premium-card">
              <span className="premium-card-icon" aria-hidden>
                {f.icon}
              </span>
              <h2>{f.title}</h2>
              <p>{f.description}</p>
              <span className="premium-lock">Función premium</span>
            </article>
          ))}
        </div>

        <section className="premium-cta">
          <h2>¿Querés agregar funciones premium?</h2>
          <p>Escribinos por WhatsApp y te contamos qué podés sumar a tu cuenta, sin compromiso.</p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="premium-wa-btn"
          >
            Consultar por WhatsApp
          </a>
        </section>
      </main>
    </div>
  );
}
